<div class="comparative-analysis-page">
  <div class="top-action-section">
    <div class="filter-container">
      <div class="filter">
        <label class="filter-label">Tickers</label>
        <div class="ticker-search-filter">
          <app-ticker-search
            [tickers]="tickers"
            [onScreen]="true"
            [isComp]="true"
            [hasSearchIcon]="true"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            [suggestedTickers]="suggestedPeers"
            placeholder="&nbsp;Add Tickers"
            [maxSelectedTickerCount]="tickerLimit"
            (onSearchedTickerUpdate)="onSearchTickerSelection($event)"
          ></app-ticker-search>

          <button
            nz-button
            class="on-screen-search__edit-btn"
            (click)="editTickers()"
            [disabled]="
              !tickerModalDataReady ||
              isMetaInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
          >
            <!-- [disabled]="
                  !(tickerModalDataReady && metaReady && !tickerDeletionInProcess)
                " -->
            Edit
          </button>
        </div>
      </div>
      <div class="filter lineitem-alignment">
        <app-lineitem-filter
          [options]="lineItemsData"
          [selectedValue]="{}"
          [selectedOptionsId]="selectedLineItemId"
          liFilterId="caTrendLI"
          [bottomBorderView]="true"
          [disabled]="
            isMetaInProgress ||
            isStdLineItemsUpdateInProgress ||
            isUserSettingUpdateInProgress
          "
          placeholder="&nbsp;Add Line Item"
          label="Line Items"
          [showButton]="true"
          (onValueChange)="handleLineItemSelection($event)"
          (onEditButtonClick)="handleEditLineItems()"
        ></app-lineitem-filter>
      </div>
      <div class="filter industry-currency-filter">
        <va-currency-select
          size="small"
          selectWidth="78"
          labelPlacement="top"
          [bottomBorderView]="true"
          [selectedCurrency]="currency"
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
          "
          [apiEP]="apiEP"
          apiUrl="/api/get_available_currencies"
          (onChange)="handleCurrencyChange($event)"
        >
        </va-currency-select>
      </div>
      <div class="filter">
        <va-period-filter
          [periodData]="periodData"
          [filterWidthVariation]="2"
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
          "
          [dataAvailable]="periodsWithAvailableData"
          [periodMinMax]="periodMinMax"
          (onApply)="handlePeriodApply($event)"
        ></va-period-filter>
      </div>
      <div class="filter">
        <app-growth-revision-filter-v2
          (saveDataview)="updateGrowthRevision($event)"
          [dataview]="dataview"
          [growthOptions]="growthOptions"
          [revisionOptions]="revisionOptions"
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
          "
        ></app-growth-revision-filter-v2>
      </div>
      <div class="filter source-alignment">
        <app-single-select-dropdown
          [disabled]="
            isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
          "
          (callback)="onSourceChange($event)"
          label="Source"
          [items]="sourceList"
          width="170px"
          [selectedItem]="source"
          [treatValueAsLable]="true"
          placeholder="Select Source"
        >
        </app-single-select-dropdown>
      </div>
    </div>
    <div class="cta-right-section">
      <!-- export button -->
      <button
        class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
        [ngClass]="[
          exportOptVisible ? 'va-button--active' : '',
          isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
            ? 'va-button--disabled'
            : ''
        ]"
        nz-popover
        nzPopoverTrigger="click"
        [nzPopoverContent]="exportOptionsTemplate"
        [(nzPopoverVisible)]="exportOptVisible"
        [nzPopoverPlacement]="'bottomRight'"
        [nzPopoverOverlayClassName]="'comps-export-popover'"
        title="Export"
      >
        <va-icon
          *ngIf="!loadingDocuments; else exportLoading"
          size="small"
          name="file-excel"
          class="va-button-icon"
        ></va-icon>
      </button>
    </div>
  </div>
  <div class="second-action-section display-flex flex-align-center">
    <div *ngIf="isActive" class="comparative-formula-bar">
      <app-subheader-formulabar
        [comparativeAnalysisBorderedFormulaBar]="true"
        [comparativeAnalysisShortFormulaBar]="true"
      ></app-subheader-formulabar>
    </div>
    <div class="display-flex">
      <div class="comparative-best-matches mr-12">
        <label class="highlisht-best-label">Highlight Best Matches</label>
        <nz-switch
          [(ngModel)]="highlightBestMatches"
          nzSize="small"
          [nzDisabled]="
            isMetaInProgress ||
            isCompsDataInProgress ||
            isUserSettingUpdateInProgress ||
            !lineItem
          "
        ></nz-switch>
        <va-icon
          size="small"
          name="info-circle"
          class="highlight-best-icon"
          nz-popover
          nzPopoverTitle="Best Match Logic"
          [nzPopoverContent]="highlightMatchesToolTipTemplate"
          nzPopoverPlacement="right"
          nzPopoverOverlayClassName="highlight-info-popover"
        ></va-icon>
      </div>
      <app-toggle-checkbox
        [disabled]="
          isMetaInProgress ||
          isCompsDataInProgress ||
          isUserSettingUpdateInProgress ||
          !lineItem
        "
        [checkboxValue]="showBlankRows"
        [label]="showBlankRowsLabel"
        [title]="false"
        labelInfo="Consensus values do not exist for all companies in all time periods."
        (onCheckboxChange)="handleShowBlanksSwitchChange($event)"
      ></app-toggle-checkbox>
    </div>
  </div>

  <div *ngIf="isMetaInProgress" style="height: 600px">
    <div nz-menu>
      <div
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </div>
    </div>
  </div>
  <section *ngIf="!isMetaInProgress" class="comparative-grid-content-section">
    <nz-collapse class="comparative-grid-collapse">
      <nz-collapse-panel
        *ngFor="let item of collapsibleList; index as i"
        [nzHeader]="
          lineItem[i] && (lineItem[i].formatted_name || lineItem[i].name)
        "
        [nzDisabled]="isCompsDataInProgress"
        [nzActive]="item.isOpen"
        (nzActiveChange)="handleCollpsibleChange({ item, i })"
      >
        <ng-container *ngIf="item.isOpen">
          <app-trend-grid
            [isActive]="isActive"
            [currentIndex]="i"
            [lineItem]="lineItem[i]"
            [industryId]="industryId"
            [metaReady]="!isMetaInProgress"
            [periodList]="periodList"
            [showBlankRows]="showBlankRows"
            [tickers]="tickers"
            [currency]="currency"
            [viewBy]="viewBy"
            [revision]="revision"
            [periodData]="periodData"
            [periodLabel]="periodLabel"
            [magnitudeMessage]="magnitudeMessage"
            [activePeriod]="activePeriod"
            [periodUserSetting]="periodUserSetting"
            [source]="source"
            [fetchAndCreateCompsData]="fetchAndCreateCompsData"
            [showCompanyCount]="showCompanyCount"
            [highlightBestMatches]="highlightBestMatches"
            [marketItemsData]="marketItemsData"
            [viewportOptions]="viewportOptions"
            [sortByColumnId]="gridSortByColumnId"
            (OnCompsDataCallInPogressChange)="
              OnCompsDataCallInPogressChange($event)
            "
            (onShowChart)="showChartPopup($event)"
            (handleTickerOrderUpdate)="handleTickerOrderUpdate($event)"
          ></app-trend-grid>
        </ng-container>
      </nz-collapse-panel>
    </nz-collapse>
    <div *ngIf="magnitudeMessage" class="comparative-trend-footer">
      {{ magnitudeMessage }}
    </div>
  </section>
</div>
<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  [(showPopup)]="chartPopupVisible"
  (closePopup)="hideChartPopup()"
></app-chart-popup>
<ng-template #exportOptionsTemplate>
  <div (click)="exportValue(1)" class="comp-export-opt">Values</div>
  <div (click)="exportValue(0)" class="comp-export-opt">
    Excel Add-In Formulas
  </div>
</ng-template>
<ng-template #exportLoading>
  <div>
    <ng-template #indicatorTemplate>
      <va-icon
        isFontAwesome="true"
        [name]="faSpinner"
        spin="true"
        class="va-button-icon"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </div>
</ng-template>

<ng-template #highlightMatchesToolTipTemplate>
  <div class="best-matches-tooltip-content">
    <p>
      Visible Alpha uses Best Match to indicate where we have identified line
      items investors want to compare but where the peers report differently.
    </p>
    <p>
      For example, Bloomin' Brands (BLMN) does not report systemwide same store
      sales (SSS), so we use domestic same stores sales growth as a proxy, while
      Brinkers International (EAT) does provide systemwide SSS. By presenting
      these in a single SSS line item, we take out much of the effort in
      constructing deep estimate Peer Analysis tables.
    </p>
    <p>
      To see the original line item being used in best match, refer to the audit
      formula bar. Best match sources are highlighted in orange within the bar.
    </p>
  </div>
</ng-template>

<!-- Snackbar -->
<div class="snack-bar-overlay" *ngIf="overlayOn"></div>
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faCheck"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faTimesCircle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #warningTemplate>
  <div class="snackbar-content warning-snack-bar">
    <va-icon
      size="small"
      name="exclamation-triangle"
      class="snack-icon snack-warning-icon"
    ></va-icon>
    <span class="snackbar-message">{{ snackbarMessage }}</span>
    <button nz-button class="snackbar-edit-btn" (click)="handleEditLineItems()">
      Edit line items
    </button>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
